// extracted by mini-css-extract-plugin
export default {"title":"Identity_title__MVbvs","mid-box":"Identity_mid-box__pyvCc","i-pin":"Identity_i-pin__dz4tw"};